import axios from "axios";
import { addEmployer, removeEmployer, updateEmployer, addEmployersList, selectEmployer } from "../app/slice/employer";
import { setActiveEmployerCode } from "../app/slice/authSlice";
import { silentHTTPCaller, toastWrapper } from "../utils/toastWrapper";
import { appDispatch } from '../app/store';
import getBaseURL from '../utils/getBaseURL';

const url = (getBaseURL() as string) + "api/v1/manage/employers";

export const createEmployer = (data, handleDone) => {
  const call = axios.post(`${url}/create`, data);
  toastWrapper(call, 'Creating employer...', (resp) => {
      appDispatch(addEmployer(resp.data.data))
      handleDone(resp.data.data);
      return resp.data.message || 'Employer created successfully!';
    }, 'Error creating employers!');
}

export const updateEmployerReq = (data, handleDone = (data: any) => {}) => {
  const call = axios.put(`${url}/update`, data)
  toastWrapper(call, 'Updating employer...', (resp) => {
    appDispatch(updateEmployer(resp.data.data));
    handleDone(resp);
    return resp.data.message || 'Employer updated successfully!';
}, 'Error updating employers!');
}

export const getEmployers = (handleDone, isSilent = false) => {
  const call = axios.get(`${url}/list`);
  if (isSilent) {
    silentHTTPCaller(call, 'loading payment history...', (resp) => {
      appDispatch(addEmployersList(resp.data.data));
      handleDone(resp.data);
      return resp.data.message || '';
    }, 'Error loading payment history');
    return;
  }
  toastWrapper(call, 'Getting employers...', (resp) => {
    appDispatch(addEmployersList(resp.data.data));
    handleDone(resp.data);
    return resp.data.message || 'Employers loaded successfully!';
  }, 'Error loading employers!');
}

export const removeEmployerReq = (id: string, handleDone) => {
  const call = axios.delete(`${url}/delete/${id}`)
  toastWrapper(call, 'Deleting employer list...', (resp) => {
    appDispatch(removeEmployer(resp.data));
    handleDone(resp.data);
    return resp.data.message || 'Employer deleted successfully!';
  }, 'Error deleting employer!');
}

export const handleSelectEmployer = (employer: any) => {
    if (!employer || !employer.id) {
        // Clear employer context
        delete axios.defaults.headers.common['EmployerId'];
        localStorage.removeItem('employer');
        localStorage.removeItem('employerCode');
        appDispatch(selectEmployer({}));
        appDispatch(setActiveEmployerCode(''));
        return;
    }

    // Set employer context
    axios.defaults.headers.common['EmployerId'] = employer.id;
    localStorage.setItem('employer', JSON.stringify(employer));
    localStorage.setItem('employerCode', employer.employerCode || '');
    appDispatch(selectEmployer(employer));
    appDispatch(setActiveEmployerCode(employer.employerCode || ''));
}

